<template>
  <div class="col-md-12 default">
    <build-usage-code />
  </div>
</template>

<script>
import buildUsageCode from "./BuildUsageCode.vue";

export default {
  components: {
    buildUsageCode
  },
  props: [],
  data() {
    return {
      
    };
  },
  computed: {},
  created() {
  },
  mounted() {
  },

  methods: {
   
  },
};
</script>
